<template>
  <div class="container mx-auto text-sm max-w-7xl flex flex-row">
    <div class="flex-col gap-4 mt-10 mr-10 hidden md:flex">
      <div class="font-bold text-base mb-6 text-[#515356] leading-[17px]">
        {{ $t('footer.links.forOwners') }}
      </div>
      <NuxtLink
        class="text-gray-500 font-bold whitespace-nowrap"
        :to="$localePath('/kak-sdat-veshchi-v-arendu')"
      >
        {{ $t('footer.links.how_to_rent_out') }}
      </NuxtLink>
      <NuxtLink
        class="text-gray-500 font-bold whitespace-nowrap"
        :to="$localePath('/pravila-publikacii')"
      >
        {{ $t('footer.links.rules_for_publishing_ads') }}
      </NuxtLink>
      <NuxtLink
        class="text-gray-500 font-bold whitespace-nowrap"
        :to="$localePath('/prokatnym-kompaniyam')"
      >
        {{ $t('footer.links.for_rental_companies') }}
      </NuxtLink>
    </div>

    <div>
      <h1 class="text-2xl font-bold mb-6 text-center">Как успешно сдать вещь в аренду?</h1>

      <!-- Видео 1 -->
      <div class="my-6">
        <iframe
          src="https://vkvideo.ru/video_ext.php?oid=-57402542&id=456239176&hd=2"
          width="100%"
          :height="$breakpoints.lMd ? '480px' : '270px'"
          style="background-color: #000"
          allow="encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
          frameborder="0"
          allowfullscreen
        />
      </div>
      <!-- Соц. сети под видео 1 -->
      <div class="flex items-center justify-center gap-4 mb-10">
        <RmSocialIconSecond name="vk" />
        <RmSocialIconSecond name="ok" />
        <RmSocialIconSecond name="tiktok" />
        <RmSocialIconSecond name="youtube" />
      </div>

      <!-- Контент с шагами -->
      <div class="space-y-6">
        <div>
          <h2 class="text-lg font-bold mb-2">Шаг 1: Регистрация и настройка профиля</h2>
          <p class="mb-2">Прежде всего, убедитесь, что вы зарегистрировались на нашей платформе. Это позволит вам полноценно пользоваться всеми возможностями сайта и получать уведомления о заказах.</p>
          <div class="font-semibold mb-1">Что нужно сделать:</div>
          <ul class="list-disc list-inside space-y-1">
            <li>Добавьте свой номер телефона, электронную почту и никнейм в Telegram.</li>
            <li>Эти данные необходимы для своевременного информирования вас о поступающих запросах.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-lg font-bold mb-2">Шаг 2: Определение стоимости аренды</h2>
          <p class="mb-2">Правильная цена – залог успеха вашего объявления. Следуйте нашим рекомендациям:</p>
          <ul class="list-disc list-inside space-y-1">
            <li>Установите цену не более 10% от рыночной стоимости нового товара, но не выше, чем у других прокатных компаний.</li>
            <li>Вы можете установить сумму залога, которая должна составлять не более 30% от стоимости новой вещи. Сообщите об этом нашим менеджерам и они установят Депозит на ваш ЛОТ.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-lg font-bold mb-2">Шаг 3: Размещение товара</h2>
          <p class="mb-2">Процесс размещения абсолютно бесплатен. Нажмите кнопку <NuxtLink
            :to="$localePath('/lots/new')"
            class="text-blue-600 hover:underline"
          >
            «Сдать в аренду»
          </NuxtLink>, чтобы начать.</p>
          <div class="font-semibold mb-1">Важные моменты:</div>
          <ul class="list-disc list-inside space-y-1">
            <li>Опишите лот детально, сделайте качественные фотографии, не менее 3-х фото.</li>
            <li>Правильно выберите категорию, чтобы облегчить поиск вашим потенциальным клиентам.</li>
            <li>Укажите точное местоположение, поскольку многие предпочитают брать в аренду близлежащие товары.</li>
            <li>
              Придерживайтесь наших
              <a
                href="https://polka.rent/ru/pravila-publikacii"
                target="_blank"
                class="text-blue-600 hover:underline"
              >Правил публикации объявлений</a>.
            </li>
          </ul>
        </div>

        <div>
          <h2 class="text-lg font-bold mb-2">Шаг 4: Продвижение и обработка запросов</h2>
          <p class="mb-2">Мы активно продвигаем ваш товар среди наших пользователей. Ваша задача – оперативно отвечать на запросы потенциальных арендаторов (чем быстрее и оперативнее вы отвечаете на запросы, тем больше вероятности, что арендуют именно Ваш ЛОТ).</p>
          <div class="font-semibold mb-1">Порядок обработки заявок:</div>
          <ul class="list-disc list-inside space-y-1">
            <li>Запросы приходят через email, СМС, WhatsApp и Telegram.</li>
            <li>Если вы не можете принять заявку, отклоните её и по возможности поясните причину отказа в личном сообщении.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-lg font-bold mb-2">Шаг 5: Подтверждение сделки</h2>
          <p class="mb-2">При согласовании аренды арендатор обязан внести предоплату. Ваш статус заказа обновится автоматически.</p>
          <div class="font-semibold mb-1">Завершающие этапы:</div>
          <ul class="list-disc list-inside space-y-1">
            <li>Передайте вещь лично или курьером, подтвердив передачу нажатием кнопки «я передал вещь».</li>
            <li>Ваше вознаграждение будет переведено на указанный вами метод выплаты.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-lg font-bold mb-2">Шаг 6: Окончание аренды</h2>
          <p class="mb-2">По завершении срока аренды обязательно проверьте возвращенную вещь и отметьте завершение процесса в системе.</p>

        </div>

        <div>
          <h2 class="text-lg font-bold mb-2">Дополнительные рекомендации:</h2>
          <p class="mb-2">Оставляйте отзывы о нашем сервисе, чтобы помочь другим пользователям сделать правильный выбор.</p>
          <p>
            <a
              href="https://clck.ru/3MUUhf"
              target="_blank"
              class="text-blue-600 hover:underline"
            >Ссылка на Яндекс Карты</a>
          </p>
        </div>

        <div>
          <h2 class="text-lg font-bold mb-2">Советы от опытных арендодателей</h2>
          <!-- Видео 2 -->
          <div class="my-4">
            <iframe
              src="https://vkvideo.ru/video_ext.php?oid=-57402542&id=456239328&hd=2"
              width="100%"
              :height="$breakpoints.lMd ? '480px' : '270px'"
              style="background-color: #000"
              allow="encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
              frameborder="0"
              allowfullscreen
            />
          </div>
          <!-- Соц. сети под видео 2 -->
          <div class="flex items-center justify-center gap-4 mt-10">
            <RmSocialIconSecond name="vk" />
            <RmSocialIconSecond name="ok" />
            <RmSocialIconSecond name="tiktok" />
            <RmSocialIconSecond name="youtube" />
          </div>
        </div>
      </div>

      <SharedRmLink
        to="https://polka.rent/ru/lots/new"
        target="_blank"
        color="blue"
        class="px-4 rounded-md max-w-screen-sm mx-auto w-full block text-center text-lg py-4 mt-10"
      >
        Сдать в аренду
      </SharedRmLink>

      <div class="text-center text-lg font-bold my-10"> Остались вопросы? </div>

      <SharedFeedbackForm />
    </div>
  </div>
</template>

<script setup>
import RmSocialIconSecond from '~/components/footer/social_icon_second.vue'

useHead({
  title: 'Как сдать в аренду',
  meta: [
    { name: 'description', content: 'Руководство для арендодателей от POLKA: шаги, видео, ссылки и полезные рекомендации.' },
  ],
})
</script>

<style lang="scss" scoped></style>
